let language = {
    STANDARD_ORDERS_IS_EMPTY_TIP: "Your order is empty.",
    STANDARD_ORDERS_SEARCH_EMPTY_TIP: "No eligible orders, please try other search criteria.",
    SEARCH_ORDERS_ITEM_SEARCH_EMPTY_TIP: "No eligible  order items, please try other search criteria.",
    
    STANDARD_ORDERS_CANCEL_ORDER_ALERT_TITLE: "Success",
    STANDARD_ORDERS_CANCEL_ORDER_ALERT_CONTENT: "Cancel Order Success",
};

export { language }